(function() {
  function wrapVariantAvailability() {
    if (!window.theme || !theme.VariantAvailability) return;
    const proto = theme.VariantAvailability.prototype;
    if (proto._starfireInstockWrapped) return;
    proto._starfireInstockWrapped = true;

    const originalCreate = proto.createAvailableOptionsTree;
    proto.createAvailableOptionsTree = function(variants, currentlySelectedValues) {
      const tree = originalCreate.call(this, variants, currentlySelectedValues);
      const currentOption1 = currentlySelectedValues.find(({index}) => index === 'option1');
      const currentOption2 = currentlySelectedValues.find(({index}) => index === 'option2');

      variants.forEach((variant) => {
        Object.keys(tree).forEach((index) => {
          if (variant[index] == null) return;
          const entry = tree[index].find((option) => option.value === variant[index]);
          if (!entry) return;
          const inStock = variantHasStock(variant);
          if (!inStock) return;
          if (index === 'option1') {
            entry.inStock = true;
          } else if (index === 'option2' && currentOption1 && variant.option1 === currentOption1.value) {
            entry.inStock = true;
          } else if (
            index === 'option3' &&
            currentOption1 &&
            currentOption2 &&
            variant.option1 === currentOption1.value &&
            variant.option2 === currentOption2.value
          ) {
            entry.inStock = true;
          }
        });
      });
      return tree;
    };

    const originalEnable = proto.enableVariantOption;
    proto.enableVariantOption = function(group, obj) {
      originalEnable.call(this, group, obj);
      if (this.type === 'dropdown' || !group) return;
      const value = obj.value.replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g, '\\$1');
      const buttonGroup = group.querySelector('.variant-input[data-value="' + value + '"]');
      if (!buttonGroup) return;
      const input = buttonGroup.querySelector('input');
      const label = buttonGroup.querySelector('label');
      if (!input || !label) return;
      input.classList.toggle('instock', Boolean(obj.inStock));
      label.classList.toggle('instock', Boolean(obj.inStock));
    };
  }

  function variantHasStock(variant) {
    if (!variant || !variant.available) return false;
    if (variant.inventory_management == null || variant.inventory_management === '') return true;
    return (parseInt(variant.inventory_quantity, 10) || 0) > 0;
  }

  function applyInstockFromJson(root) {
    const scope = root || document;
    scope.querySelectorAll('[data-variant-json]').forEach((jsonEl) => {
      const container = jsonEl.closest('[data-section-type="product"]') || jsonEl.closest('[data-section-id]') || scope;
      let variants;
      try {
        variants = JSON.parse(jsonEl.textContent);
      } catch (err) {
        return;
      }
      if (!Array.isArray(variants) || !variants.length) return;
      if (!variants.some((variant) => variant.hasOwnProperty('inventory_quantity'))) return;

      const selected = {};
      container.querySelectorAll('[data-variant-input]:checked').forEach((input) => {
        if (input.dataset.index) selected[input.dataset.index] = input.value;
      });

      container.querySelectorAll('.variant-input-wrap').forEach((group) => {
        const index = group.dataset.index;
        if (!index) return;
        group.querySelectorAll('.variant-input[data-value]').forEach((wrap) => {
          const value = wrap.getAttribute('data-value');
          const inStock = variants.some((variant) => {
            if (variant[index] !== value || !variantHasStock(variant)) return false;
            if (index === 'option1') return true;
            if (index === 'option2') return variant.option1 === selected.option1;
            if (index === 'option3') return variant.option1 === selected.option1 && variant.option2 === selected.option2;
            return false;
          });
          const input = wrap.querySelector('input');
          const label = wrap.querySelector('label');
          if (input) input.classList.toggle('instock', inStock);
          if (label) label.classList.toggle('instock', inStock);
        });
      });
    });
  }

  function seedCurrentVariantIntoOptions(options) {
    if (!options || !options.container || !Array.isArray(options.variants)) return options;
    const currentEl = options.container.querySelector('[data-current-variant-json]');
    if (!currentEl) return options;
    try {
      const current = JSON.parse(currentEl.textContent);
      if (current && current.id && !options.variants.some(function(variant) {
        return String(variant.id) === String(current.id);
      })) {
        options.variants = options.variants.concat([current]);
      }
    } catch (err) {}
    return options;
  }

  function rebindVariantChangeListeners(variantsUi) {
    if (!variantsUi || !variantsUi.container || !variantsUi.singleOptionSelector) return;
    if (variantsUi._starfireChangeRebound) return;
    variantsUi._starfireChangeRebound = true;

    variantsUi.container.querySelectorAll(variantsUi.singleOptionSelector).forEach(function(el) {
      if (!el.parentNode) return;
      // Drop Impulse's construct-time .bind(this) listener (keeps the original
      // _onSelectChange forever). Clone preserves checked/value state.
      const clone = el.cloneNode(true);
      el.parentNode.replaceChild(clone, el);
      clone.addEventListener('change', function(evt) {
        onVariantInputChange(variantsUi, clone, evt);
      });
    });
  }

  function onVariantInputChange(variantsUi, input, evt) {
    const container = variantsUi && variantsUi.container;
    if (!container || !input) return;

    // Live path first: resolve from in-memory variants (includes Liquid seed +
    // any previously fetched high-variant rows). Only hit section HTML when
    // the combo is missing from the truncated >250 JSON.
    if (theme.Variants) {
      const local = variantsUi._getVariantFromOptions({
        index: input.dataset && input.dataset.index,
        value: input.value
      });
      if (local || !isHighVariantProduct(container)) {
        theme.Variants.prototype._onSelectChange.call(variantsUi, evt || {
          srcElement: input,
          target: input
        });
        return;
      }
    }

    if (!isHighVariantProduct(container)) return;

    if (evt && evt.stopImmediatePropagation) evt.stopImmediatePropagation();
    const requestId = (container._starfireOptionRequestId || 0) + 1;
    container._starfireOptionRequestId = requestId;
    fetchHighVariantSection(container, selectedOptionValueIds(container))
      .then(function(html) {
        if (container._starfireOptionRequestId !== requestId) return;
        applyHighVariantPayload(container, html, input);
      })
      .catch(function() {
        if (theme.Variants) {
          theme.Variants.prototype._onSelectChange.call(variantsUi, {
            srcElement: input,
            target: input
          });
        }
      });
  }

  function wrapVariantsConstructor() {
    if (!window.theme || !theme.Variants || theme.Variants._starfireCtorWrapped) return;
    const Original = theme.Variants;
    function StarfireVariants(options) {
      Original.call(this, seedCurrentVariantIntoOptions(options));
      // Only rebind inputs for opt-in high-variant fetch. Cloning radios on every
      // classic PDP broke cold-load listeners (metal unresponsive until family switch).
      if (options && options.container && isHighVariantProduct(options.container)) {
        rebindVariantChangeListeners(this);
      }
      if (this.container) {
        this.container._starfireVariants = this;
      }
    }
    StarfireVariants.prototype = Original.prototype;
    StarfireVariants._starfireCtorWrapped = true;
    theme.Variants = StarfireVariants;
  }

  function wrapVariantSelection() {
    if (!window.theme || !theme.Variants) return;
    wrapVariantsConstructor();
    const proto = theme.Variants.prototype;
    if (proto._starfireStableOptions) return;
    proto._starfireStableOptions = true;

    // Live theme.js: availableFullMatch || fullMatch (no closestAvailableMatch).
    // Closest-match was remapping invalid QuickShop combos (e.g. 6ga + 5mm disk)
    // onto a nearby sellable variant so ATC stayed enabled.
    proto._getVariantFromOptions = function() {
      const availableFullMatch = this._getFullMatch(true);
      const fullMatch = this._getFullMatch(false);
      if (availableFullMatch) return availableFullMatch;
      // Exact combo exists but is sold out — still return it so ATC shows Sold out,
      // never a neighboring gauge/length/disk.
      return fullMatch || null;
    };

    // Live _updateInputState is plain — do not skip preceding options.

    // Live _onSelectChange order, plus forcedVariant for high-variant section fetch.
    proto._onSelectChange = function(evt) {
      const srcElement = evt && (evt.srcElement || evt.target);
      if (!srcElement && !(evt && evt.forcedVariant)) return;

      const optionSelectElements = this.container.querySelectorAll(this.singleOptionSelector);
      const lastSelected = srcElement ? {
        index: srcElement.dataset && srcElement.dataset.index,
        value: srcElement.value
      } : null;
      const variant = (evt && evt.forcedVariant) || this._getVariantFromOptions(lastSelected);

      if (srcElement) {
        optionSelectElements.forEach(this._updateInputState(variant, srcElement));
      } else if (variant) {
        optionSelectElements.forEach(this._updateInputState(variant, {
          dataset: { index: 'option1' },
          value: variant.option1
        }));
      }

      const currentlySelectedValues = this.currentlySelectedValues = this._getCurrentOptions();
      const detail = {
        variant: variant,
        currentlySelectedValues: currentlySelectedValues,
        value: srcElement ? srcElement.value : (variant && variant.option1),
        index: (srcElement && srcElement.parentElement && srcElement.parentElement.dataset.index) ||
          (srcElement && srcElement.dataset && srcElement.dataset.index) ||
          'option1'
      };

      try {
        this.container.dispatchEvent(new CustomEvent('variantChange', { detail: detail }));
        document.dispatchEvent(new CustomEvent('variant:change', { detail: detail }));
      } catch (err) {}

      if (!variant) return;

      try { this._updateMasterSelect(variant); } catch (err) {}
      try { this._updateImages(variant); } catch (err) {}
      try { this._updatePrice(variant); } catch (err) {}
      try { this._updateUnitPrice(variant); } catch (err) {}
      try { this._updateSKU(variant); } catch (err) {}
      this.currentVariant = variant;
      if (this.enableHistoryState) {
        try { this._updateHistoryState(variant); } catch (err) {}
      }
    };

    // Live gates on featured_image src; also fire when featured_media id changes
    // (metal swaps often share price but not media).
    proto._updateImages = function(variant) {
      if (!variant) return;
      const variantImage = variant.featured_image || {};
      const currentVariantImage = (this.currentVariant && this.currentVariant.featured_image) || {};
      const nextMediaId = variant.featured_media && variant.featured_media.id;
      const prevMediaId = this.currentVariant && this.currentVariant.featured_media &&
        this.currentVariant.featured_media.id;

      if (!variant.featured_image && nextMediaId == null) return;
      if (
        variant.featured_image &&
        variantImage.src === currentVariantImage.src &&
        String(nextMediaId || '') === String(prevMediaId || '')
      ) {
        return;
      }

      this.container.dispatchEvent(new CustomEvent('variantImageChange', {
        detail: { variant: variant }
      }));
    };

    // Live always fires price change (same-price early-return is commented out).
    const originalUpdatePrice = proto._updatePrice;
    proto._updatePrice = function(variant) {
      if (!variant) return;
      if (
        this.currentVariant &&
        this.currentVariant.id !== variant.id &&
        variant.price === this.currentVariant.price &&
        variant.compare_at_price === this.currentVariant.compare_at_price
      ) {
        this.container.dispatchEvent(new CustomEvent('variantPriceChange', {
          detail: { variant: variant }
        }));
        return;
      }
      return originalUpdatePrice.call(this, variant);
    };

    const originalHistory = proto._updateHistoryState;
    proto._updateHistoryState = function(variant) {
      const y = window.scrollY;
      originalHistory.call(this, variant);
      if (Math.abs(window.scrollY - y) > 1) window.scrollTo(0, y);
    };
  }

  function findImageSetOptionWrapper(container, imageSetName) {
    if (!container || !imageSetName) return null;
    let wrap = container.querySelector('.variant-input-wrap[data-handle="' + imageSetName + '"]');
    if (wrap) return wrap;

    const aliases = {
      gem: ['gemstone', 'gem-color', 'gem-colour', 'stone', 'color', 'colour'],
      gemstone: ['gem', 'gem-color', 'gem-colour', 'stone'],
      'gem-color': ['gem', 'gemstone', 'gem-colour'],
      'gem-colour': ['gem', 'gemstone', 'gem-color'],
      color: ['colour', 'gem', 'gemstone'],
      colour: ['color', 'gem', 'gemstone'],
      metal: ['material', 'finish'],
      material: ['metal', 'finish']
    };
    const list = aliases[imageSetName] || [];
    for (let i = 0; i < list.length; i++) {
      wrap = container.querySelector('.variant-input-wrap[data-handle="' + list[i] + '"]');
      if (wrap) return wrap;
    }

    const all = container.querySelectorAll('.variant-input-wrap[data-handle]');
    for (let i = 0; i < all.length; i++) {
      const handle = all[i].getAttribute('data-handle') || '';
      if (
        handle === imageSetName ||
        handle.indexOf(imageSetName) === 0 ||
        imageSetName.indexOf(handle) === 0
      ) {
        return all[i];
      }
    }
    return null;
  }

  function ensureImageSetWiring(product) {
    if (!product || !product.container || !product.settings) return false;
    if (!product.cache || !product.cache.mainSlider) return false;
    const dataSetEl = product.cache.mainSlider.querySelector('[data-set-name]');
    if (!dataSetEl) return false;
    const setName = dataSetEl.getAttribute('data-set-name') || dataSetEl.dataset.setName;
    if (!setName) return false;
    const wrapper = findImageSetOptionWrapper(product.container, setName);
    if (!wrapper) return false;

    const wasDisabled = !product.settings.imageSetName || !product.settings.imageSetIndex;
    product.settings.imageSetName = setName;
    product.settings.imageSetIndex = wrapper.dataset.index;

    // Only re-bind when Impulse nulled image sets (handle mismatch). Avoid duplicate listeners.
    if (wasDisabled && !product._starfireImageSetBound && typeof product.container.on === 'function') {
      product._starfireImageSetBound = true;
      product.container.on(
        'variantChange' + product.settings.namespace,
        product.updateImageSet.bind(product)
      );
    }
    return true;
  }

  function syncThumbsToCurrentSet(product) {
    if (!product || !product.variants || !product.variants.currentVariant) return;
    const variant = product.variants.currentVariant;
    ensureImageSetWiring(product);
    if (!product.settings.imageSetName || !product.settings.imageSetIndex) return;
    if (!variant[product.settings.imageSetIndex]) return;

    const setValue = product.getImageSetName(variant[product.settings.imageSetIndex]);
    const set = product.settings.imageSetName + '_' + setValue;
    product.settings.currentImageSet = setValue;
    if (typeof product.updateImageSetThumbs === 'function') {
      product.updateImageSetThumbs(set);
    }

    // Trust Liquid / Flickity starting slide for the hero — do not goTo featured_media
    // on load (that override broke metal image swaps afterward).
    const start =
      (product.cache &&
        product.cache.mainSlider &&
        (product.cache.mainSlider.querySelector('.product-main-slide.is-selected') ||
          product.cache.mainSlider.querySelector('.product-main-slide.starting-slide'))) ||
      null;
    const mediaId = start && start.getAttribute('data-media-id');
    if (mediaId) syncActiveThumb(product, mediaId);
  }

  function syncThumbsWithRetries(product, attemptsLeft) {
    syncThumbsToCurrentSet(product);
    if (!attemptsLeft || attemptsLeft <= 0) return;
    const hasThumbs =
      product.cache &&
      product.cache.thumbSlider &&
      product.cache.thumbSlider.querySelector('.product__thumb-item:not(.hide)');
    if (hasThumbs) return;
    setTimeout(function() {
      syncThumbsWithRetries(product, attemptsLeft - 1);
    }, 40);
  }

  function wrapProductImageSetSlider() {
    if (!window.theme || !theme.Product) return;
    const proto = theme.Product.prototype;
    if (proto._starfireImageSetWrapped) return;
    proto._starfireImageSetWrapped = true;

    // goToSlide by media id (thumb data-id) — live gallery needs this for filtered cells.
    if (theme.Slideshow && !theme.Slideshow.prototype._starfireLiveGallery) {
      theme.Slideshow.prototype._starfireLiveGallery = true;

      theme.Slideshow.prototype.goToSlide = function(mediaIdOrIndex) {
        const slideshow = this.slideshow;
        if (!slideshow || !slideshow.cells || !slideshow.cells.length) return;
        const id = String(mediaIdOrIndex);
        for (let c = 0; c < slideshow.cells.length; c++) {
          if (String(slideshow.cells[c].element.dataset.mediaId) === id) {
            slideshow.select(c);
            return;
          }
        }
        const asIndex = parseInt(mediaIdOrIndex, 10);
        if (!isNaN(asIndex) && String(asIndex) === id && asIndex >= 0 && asIndex < slideshow.cells.length) {
          slideshow.select(asIndex);
        }
      };

      theme.Slideshow.prototype.childNavGoTo = function(index) {
        if (!this.childNavLinks || !this.childNavLinks.length) return;
        const slide = this.slideshow && this.slideshow.cells && this.slideshow.cells[index]
          ? this.slideshow.cells[index].element
          : null;
        const mediaId = slide && slide.getAttribute('data-media-id');
        this.childNavLinks.forEach(function(link) {
          const active = mediaId
            ? String(link.getAttribute('data-id')) === String(mediaId)
            : false;
          link.classList.toggle('is-active', active);
        });
        let el = null;
        if (mediaId) {
          this.childNavLinks.forEach(function(link) {
            if (String(link.getAttribute('data-id')) === String(mediaId)) el = link;
          });
        }
        if (!el) {
          el = this.childNavLinks[index];
          if (el) el.classList.add('is-active');
        }
        if (!el) return;

        const scroller = this.args.childNavScroller;
        if (!scroller) return;
        const elRect = el.getBoundingClientRect();
        const box = scroller.getBoundingClientRect();
        const visible = this.args.childVertical
          ? elRect.top >= box.top && elRect.bottom <= box.bottom
          : elRect.left >= box.left && elRect.right <= box.right;
        if (visible) return;
        if (this.args.childVertical) {
          scroller.scrollTop += elRect.top - box.top - 8;
        } else {
          scroller.scrollLeft += elRect.left - box.left - 8;
        }
      };

      // Live: thumb click dispatches product:switchVariantByOptions so options/price/SKU/URL update.
      const originalInitChildNav = theme.Slideshow.prototype.initChildNav;
      theme.Slideshow.prototype.initChildNav = function() {
        originalInitChildNav.call(this);
        if (!this.childNavLinks || !this.childNavLinks.length) return;
        if (this._starfireThumbVariantBound) return;
        this._starfireThumbVariantBound = true;
        const slideshow = this;
        this.childNavLinks.forEach(function(link) {
          link.addEventListener('click', function(evt) {
            const productThumb = evt.currentTarget && evt.currentTarget.closest
              ? evt.currentTarget.closest('.product__thumb-item')
              : null;
            if (!productThumb) return;
            const section = (slideshow.el && slideshow.el.closest
              ? slideshow.el.closest('[data-section-type="product"]')
              : null) || (productThumb.closest && productThumb.closest('[data-section-type="product"]'));
            if (!section) return;
            const nextOptions = [
              productThumb.getAttribute('data-variant-option1'),
              productThumb.getAttribute('data-variant-option2'),
              productThumb.getAttribute('data-variant-option3')
            ].filter(function(el) { return el && el !== '[]'; });
            const variantId = productThumb.getAttribute('data-variant-id') ||
              (evt.currentTarget && evt.currentTarget.getAttribute('data-variant-id'));
            section.dispatchEvent(new CustomEvent('product:switchVariantByOptions', {
              bubbles: true,
              detail: {
                options: nextOptions.length ? [
                  productThumb.getAttribute('data-variant-option1') || '[]',
                  productThumb.getAttribute('data-variant-option2') || '[]',
                  productThumb.getAttribute('data-variant-option3') || '[]'
                ] : nextOptions,
                variantId: variantId || null,
                thumb: productThumb
              }
            }));
          });
        });
      };
    }

    // Live: thumb click selects the variant for that image (options + price + SKU + URL).
    // Prefer data-variant-id / media match; option JSON attrs are a secondary path.
    proto.switchVariantByOptions = function(evt) {
      if (evt && evt.target && this.container &&
          evt.target !== this.container && !this.container.contains(evt.target)) {
        return;
      }
      const detail = evt && evt.detail;
      if (detail && detail.variant) {
        this._starfireApplyVariant(detail.variant);
        return;
      }
      if (detail && detail.variantId) {
        const fromId = this._starfireVariantById(detail.variantId);
        if (fromId) {
          this._starfireApplyVariant(fromId);
          return;
        }
      }
      if (detail && detail.thumb) {
        const fromThumb = this._starfireVariantForThumb(detail.thumb);
        if (fromThumb) {
          this._starfireApplyVariant(fromThumb);
          return;
        }
      }
      const variantOptions = detail && detail.options;
      if (!variantOptions || !variantOptions.length) return;

      let didChange = false;
      for (let optionIndex0 = 0; optionIndex0 < 3; optionIndex0++) {
        const raw = variantOptions[optionIndex0];
        if (!raw || raw === '[]') continue;
        let optionValuesArr;
        try {
          optionValuesArr = JSON.parse(raw);
        } catch (err) {
          continue;
        }
        if (!optionValuesArr || !optionValuesArr.length) continue;

        const optionIndex = optionIndex0 + 1;
        const inputs = this.container.querySelectorAll(
          this.selectors.singleOptionSelector + '[data-index="option' + optionIndex + '"]'
        );
        if (!inputs.length) continue;

        let selectedOption = false;
        inputs.forEach(function(input) {
          if (input.type === 'radio' || input.type === 'checkbox') {
            if (input.checked) selectedOption = input.value;
          } else {
            selectedOption = input.value;
          }
        });
        if (selectedOption && optionValuesArr.indexOf(selectedOption) !== -1) continue;

        const wanted = optionValuesArr[0];
        let optionEl = null;
        inputs.forEach(function(input) {
          if (!optionEl && input.value === wanted) optionEl = input;
        });
        if (!optionEl) continue;
        if (optionEl.type === 'radio' || optionEl.type === 'checkbox') {
          optionEl.checked = true;
        } else {
          optionEl.value = wanted;
        }
        // Live: fire change per option so Variants updates price/SKU/URL.
        optionEl.dispatchEvent(new Event('change', { bubbles: true }));
        didChange = true;
      }

      if (didChange) return;
      // Options already matched arrays — still try media/id resolution from thumb.
      if (detail && detail.thumb) {
        const again = this._starfireVariantForThumb(detail.thumb);
        if (again) this._starfireApplyVariant(again);
      }
    };

    proto._starfireVariantById = function(id) {
      if (id == null || !this.container) return null;
      const variantsUi = this.variants || this.container._starfireVariants;
      const list = (variantsUi && variantsUi.variants) || this.variantsObject || [];
      const want = String(id);
      for (let i = 0; i < list.length; i++) {
        if (String(list[i].id) === want) return list[i];
      }
      return null;
    };

    proto._starfireSyncOptionInputs = function(variant) {
      if (!variant || !this.container) return null;
      let lastEl = null;
      for (let n = 1; n <= 3; n++) {
        const wanted = variant['option' + n];
        if (wanted == null || wanted === '') continue;
        const inputs = this.container.querySelectorAll(
          this.selectors.singleOptionSelector + '[data-index="option' + n + '"]'
        );
        inputs.forEach(function(input) {
          if (input.type === 'radio' || input.type === 'checkbox') {
            const match = input.value === wanted;
            input.checked = match;
            if (match) lastEl = input;
          } else {
            input.value = wanted;
            lastEl = input;
          }
        });
      }
      return lastEl;
    };

    proto._starfireApplyVariant = function(forcedVariant, srcElement) {
      const variantsUi = this.variants || (this.container && this.container._starfireVariants);
      if (!forcedVariant && srcElement) {
        if (variantsUi && theme.Variants && theme.Variants.prototype._onSelectChange) {
          theme.Variants.prototype._onSelectChange.call(variantsUi, {
            srcElement: srcElement,
            target: srcElement
          });
        } else {
          srcElement.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }
      if (!forcedVariant) return;

      const lastEl = this._starfireSyncOptionInputs(forcedVariant);
      if (!variantsUi || !theme.Variants || !theme.Variants.prototype._onSelectChange) {
        if (lastEl) lastEl.dispatchEvent(new Event('change', { bubbles: true }));
        else if (history.replaceState) {
          const newurl = window.location.protocol + '//' + window.location.host +
            window.location.pathname + '?variant=' + forcedVariant.id;
          window.history.replaceState({ path: newurl }, '', newurl);
        }
        return;
      }

      // Ensure URL updates even if Impulse left enableHistoryState falsy.
      const prevHistory = variantsUi.enableHistoryState;
      variantsUi.enableHistoryState = true;
      theme.Variants.prototype._onSelectChange.call(variantsUi, {
        forcedVariant: forcedVariant,
        srcElement: lastEl || null,
        target: lastEl || null
      });
      variantsUi.enableHistoryState = prevHistory;

      if (history.replaceState && forcedVariant.id) {
        const newurl = window.location.protocol + '//' + window.location.host +
          window.location.pathname + '?variant=' + forcedVariant.id;
        if (window.location.search.indexOf('variant=' + forcedVariant.id) === -1) {
          window.history.replaceState({ path: newurl }, '', newurl);
        }
      }
    };

    proto._starfireVariantForThumb = function(thumb) {
      if (!thumb || !this.container) return null;
      const variantsUi = this.variants || this.container._starfireVariants;
      const list = (variantsUi && variantsUi.variants) || this.variantsObject || [];
      if (!list.length) return null;

      const byAttr = thumb.getAttribute('data-variant-id') ||
        (thumb.querySelector && thumb.querySelector('[data-variant-id]') &&
          thumb.querySelector('[data-variant-id]').getAttribute('data-variant-id'));
      if (byAttr) {
        const direct = this._starfireVariantById(byAttr);
        if (direct) return direct;
      }

      const link = thumb.querySelector('a[data-product-thumb][data-id]');
      const mediaId = link && link.getAttribute('data-id');
      const current = variantsUi && variantsUi.currentVariant;

      const matchesMedia = function(variant) {
        if (!variant || mediaId == null) return false;
        const id = String(mediaId);
        if (variant.featured_media && String(variant.featured_media.id) === id) return true;
        if (variant.featured_image && String(variant.featured_image.id) === id) return true;
        return false;
      };

      let matches = list.filter(matchesMedia);

      // Fall back to option tags when media ids differ (image id vs media id).
      if (!matches.length) {
        const optionSets = [1, 2, 3].map(function(n) {
          try {
            return JSON.parse(thumb.getAttribute('data-variant-option' + n) || '[]');
          } catch (err) {
            return [];
          }
        });
        if (optionSets.some(function(set) { return set.length; })) {
          matches = list.filter(function(variant) {
            return optionSets.every(function(set, idx) {
              if (!set.length) return true;
              const key = 'option' + (idx + 1);
              return !variant[key] || set.indexOf(variant[key]) !== -1;
            });
          });
        }
      }

      if (!matches.length) return null;

      matches.sort(function(a, b) {
        let scoreA = 0;
        let scoreB = 0;
        if (current) {
          if (a.option1 === current.option1) scoreA += 4;
          if (a.option2 === current.option2) scoreA += 2;
          if (a.option3 === current.option3) scoreA += 1;
          if (b.option1 === current.option1) scoreB += 4;
          if (b.option2 === current.option2) scoreB += 2;
          if (b.option3 === current.option3) scoreB += 1;
        }
        if (a.available) scoreA += 8;
        if (b.available) scoreB += 8;
        return scoreB - scoreA;
      });

      return matches[0];
    };

    const originalInit = proto.init;
    proto.init = function() {
      const result = originalInit.call(this);
      if (this.container) {
        this.container._starfireProduct = this;
        if (this.variants) this.container._starfireVariants = this.variants;
        if (this.variantsObject) this.container._starfireVariantsObject = this.variantsObject;
        // Capture-phase delegation: runs even if slideshow stopPropagation is added later.
        if (!this.container._starfireThumbDelegate) {
          this.container._starfireThumbDelegate = true;
          this.container.addEventListener('click', function(evt) {
            const link = evt.target && evt.target.closest && evt.target.closest('a[data-product-thumb]');
            if (!link || !this.container.contains(link)) return;
            const productThumb = link.closest('.product__thumb-item');
            if (!productThumb) return;
            const variant = this._starfireVariantForThumb(productThumb);
            if (!variant) return;
            const variantsUi = this.variants || this.container._starfireVariants;
            if (variantsUi && variantsUi.currentVariant &&
                String(variantsUi.currentVariant.id) === String(variant.id)) {
              // Still ensure URL has the variant param.
              if (history.replaceState && window.location.search.indexOf('variant=' + variant.id) === -1) {
                const newurl = window.location.protocol + '//' + window.location.host +
                  window.location.pathname + '?variant=' + variant.id;
                window.history.replaceState({ path: newurl }, '', newurl);
              }
              return;
            }
            this._starfireApplyVariant(variant);
          }.bind(this), true);
        }
      }
      ensureImageSetWiring(this);
      syncThumbsWithRetries(this, 8);
      return result;
    };

    // Mirror live theme.js (also patched there for first paint before this file loads).
    proto.imageSetArguments = function(variant) {
      variant = variant ? variant : (this.variants ? this.variants.currentVariant : null);
      if (!variant || !this.settings.imageSetName || !this.settings.imageSetIndex) return;

      const setValue = this.settings.currentImageSet = this.getImageSetName(variant[this.settings.imageSetIndex]);
      const set = this.settings.imageSetName + '_' + setValue;
      this.settings.currentSlideIndex = 0;

      const cells = Array.from(this.container.querySelectorAll(
        '.product-main-slide:not([data-group]), .product-main-slide[data-group="' + set + '"]'
      ));
      let initialIndex = cells.findIndex(function(el) {
        return el.classList.contains('starting-slide');
      });
      if (initialIndex < 0) initialIndex = 0;
      this.settings.currentSlideIndex = initialIndex;

      return {
        cellSelector: '.product-main-slide:not([data-group]), [data-group="' + set + '"]',
        imageSet: set,
        initialIndex: initialIndex
      };
    };

    proto.updateImageSetThumbs = function(set) {
      if (!this.cache || !this.cache.thumbSlider || !set) return;
      this.cache.thumbSlider.querySelectorAll('.product__thumb-item').forEach(function(thumb) {
        if (thumb.dataset.group !== undefined) {
          thumb.classList.toggle('hide', thumb.dataset.group !== set);
        }
      });
      refreshVisibleThumbNav(this);
    };

    // Live: remount only when the image-set option value changes.
    proto.updateImageSet = function(evt) {
      try {
        ensureImageSetWiring(this);
        const variant = evt ? evt.detail.variant : (this.variants ? this.variants.currentVariant : null);
        if (!variant) return;

        if (!this.settings.imageSetIndex && this.cache && this.cache.mainSlider) {
          const dataSetEl = this.cache.mainSlider.querySelector('[data-set-name]');
          if (dataSetEl) {
            this.settings.imageSetName = dataSetEl.getAttribute('data-set-name');
            const variantWrapper = findImageSetOptionWrapper(this.container, this.settings.imageSetName);
            if (variantWrapper) this.settings.imageSetIndex = variantWrapper.dataset.index;
          }
        }

        if (!this.settings.imageSetIndex || !this.settings.imageSetName) return;
        if (!variant[this.settings.imageSetIndex]) return;

        const setValue = this.getImageSetName(variant[this.settings.imageSetIndex]);
        if (this.settings.currentImageSet === setValue) {
          this.updateImageSetThumbs(this.settings.imageSetName + '_' + setValue);
          return;
        }

        this.settings.currentImageSet = setValue;
        this.initProductSlider(variant);
      } catch (err) {}
    };

    const originalSlideChange = proto.onSlideChange;
    proto.onSlideChange = function(index) {
      const y = window.scrollY;
      originalSlideChange.call(this, index);
      if (Math.abs(window.scrollY - y) > 1) window.scrollTo(0, y);
      const slide = this.flickity && this.flickity.slideshow && this.flickity.slideshow.cells
        && this.flickity.slideshow.cells[index]
        && this.flickity.slideshow.cells[index].element;
      if (slide && slide.getAttribute('data-media-id')) {
        syncActiveThumb(this, slide.getAttribute('data-media-id'));
      }
    };

    // Match theme.js: go to variant featured media (works with image-set filtered cells).
    proto.updateVariantImage = function(evt) {
      try {
        const variant = evt && evt.detail && evt.detail.variant;
        if (!variant || !variant.featured_media) return;
        if (this.flickity) this.flickity.goToSlide(variant.featured_media.id);
      } catch (err) {}
    };
  }

  function variantFeaturedMediaId(variant) {
    if (!variant) return null;
    if (variant.featured_media && variant.featured_media.id != null) return String(variant.featured_media.id);
    if (variant.featured_image && variant.featured_image.id != null) return String(variant.featured_image.id);
    return null;
  }

  function resolveVariantMediaId(product, variant) {
    const direct = variantFeaturedMediaId(variant);
    if (direct && product && product.cache && product.cache.mainSlider) {
      if (product.cache.mainSlider.querySelector('.product-main-slide[data-media-id="' + direct + '"]')) {
        return direct;
      }
    }

    // Liquid variant JSON sometimes only has featured_image.id (image id), while
    // slides use media.id. Fall back to thumbs tagged with this variant's options.
    if (product && product.cache && product.cache.thumbSlider && variant) {
      const thumbs = product.cache.thumbSlider.querySelectorAll('.product__thumb-item');
      for (let i = 0; i < thumbs.length; i++) {
        const thumb = thumbs[i];
        if (thumb.classList.contains('hide')) continue;
        let match = true;
        ['option1', 'option2', 'option3'].forEach(function(key, idx) {
          if (!match || !variant[key]) return;
          let values = [];
          try {
            values = JSON.parse(thumb.getAttribute('data-variant-option' + (idx + 1)) || '[]');
          } catch (err) {
            values = [];
          }
          if (!values.length || values.indexOf(variant[key]) === -1) match = false;
        });
        if (!match) continue;
        const link = thumb.querySelector('a[data-product-thumb][data-id]');
        if (link) return String(link.getAttribute('data-id'));
      }
    }

    return direct;
  }

  function markVariantStartingSlide(product, variant) {
    const mediaId = resolveVariantMediaId(product, variant);
    if (!mediaId || !product.cache || !product.cache.mainSlider) return;
    product.cache.mainSlider.querySelectorAll('.product-main-slide').forEach(function(slide) {
      const match = String(slide.getAttribute('data-media-id')) === mediaId;
      slide.classList.toggle('starting-slide', match);
      slide.classList.toggle('secondary-slide', !match);
    });
  }

  function refreshVisibleThumbNav(product) {
    if (!product || !product.flickity || !product.cache || !product.cache.thumbSlider) return;
    const root = product.cache.thumbSlider;
    product.flickity.childNavEls = root.querySelectorAll('.product__thumb-item:not(.hide)');
    product.flickity.childNavLinks = root.querySelectorAll('.product__thumb-item:not(.hide) a');
    product.flickity.childNavLinks.forEach(function(link, i) {
      link.setAttribute('data-index', String(i));
    });
  }

  function syncActiveThumb(product, mediaId) {
    if (!product || !product.cache || !product.cache.thumbSlider || mediaId == null) return;
    refreshVisibleThumbNav(product);
    const id = String(mediaId);
    let matchedLink = null;
    product.cache.thumbSlider.querySelectorAll('.product__thumb-item a[data-product-thumb]').forEach(function(link) {
      const item = link.closest('.product__thumb-item');
      const active = String(link.getAttribute('data-id')) === id && item && !item.classList.contains('hide');
      link.classList.toggle('is-active', active);
      if (active) matchedLink = link;
    });
    if (!matchedLink || !product.flickity || !product.flickity.args) return;
    const scroller = product.flickity.args.childNavScroller;
    if (!scroller) return;
    const elRect = matchedLink.getBoundingClientRect();
    const box = scroller.getBoundingClientRect();
    const visible = product.flickity.args.childVertical
      ? elRect.top >= box.top && elRect.bottom <= box.bottom
      : elRect.left >= box.left && elRect.right <= box.right;
    if (visible) return;
    if (product.flickity.args.childVertical) {
      scroller.scrollTop += elRect.top - box.top - 8;
    } else {
      scroller.scrollLeft += elRect.left - box.left - 8;
    }
  }

  function goToVariantMedia(product, variant, attempt, onlyIfDifferent) {
    if (!product || !variant) return;
    const mediaId = resolveVariantMediaId(product, variant);
    if (!mediaId) return;
    const tries = attempt || 0;

    if (product.settings && product.settings.imageSetName && product.settings.imageSetIndex) {
      const setValue = product.getImageSetName(variant[product.settings.imageSetIndex]);
      const set = product.settings.imageSetName + '_' + setValue;
      if (product.cache && product.cache.thumbSlider) {
        product.updateImageSetThumbs(set);
      }
      if (product.settings.currentImageSet !== setValue) {
        product.settings.currentImageSet = setValue;
        if (typeof product.initProductSlider === 'function') {
          product.initProductSlider(variant);
          return;
        }
      }
    }

    if (product.flickity && typeof product.flickity.goToSlide === 'function') {
      if (onlyIfDifferent) {
        const slideshow = product.flickity.slideshow;
        const selected = slideshow && slideshow.cells && slideshow.cells[slideshow.selectedIndex]
          && slideshow.cells[slideshow.selectedIndex].element;
        if (selected && String(selected.getAttribute('data-media-id')) === mediaId) {
          syncActiveThumb(product, mediaId);
          return;
        }
      }
      product.flickity.goToSlide(mediaId);
      syncActiveThumb(product, mediaId);
      return;
    }

    const slideshow = product.flickity && product.flickity.slideshow;
    if (!slideshow || !slideshow.cells || !slideshow.cells.length) {
      if (tries < 8) {
        setTimeout(function() {
          goToVariantMedia(product, variant, tries + 1, onlyIfDifferent);
        }, 50);
      }
      return;
    }

    let cellIndex = -1;
    for (let i = 0; i < slideshow.cells.length; i++) {
      if (String(slideshow.cells[i].element.dataset.mediaId) === mediaId) {
        cellIndex = i;
        break;
      }
    }

    if (cellIndex > -1) {
      if (onlyIfDifferent && slideshow.selectedIndex === cellIndex) {
        syncActiveThumb(product, mediaId);
        return;
      }
      slideshow.select(cellIndex);
      syncActiveThumb(product, mediaId);
      return;
    }

    syncActiveThumb(product, mediaId);
  }

  // Live: thumb click → product:switchVariantByOptions. Bound at document so it
  // works even if Slideshow was constructed before our prototype wrap.
  if (!window._starfireThumbVariantDocBound) {
    window._starfireThumbVariantDocBound = true;
    document.addEventListener('click', function(evt) {
      const link = evt.target && evt.target.closest && evt.target.closest('a[data-product-thumb]');
      if (!link) return;
      const productThumb = link.closest('.product__thumb-item');
      if (!productThumb) return;
      const section = link.closest('[data-section-type="product"]');
      if (!section) return;
      const product = section._starfireProduct;
      if (!product || typeof product.switchVariantByOptions !== 'function') return;
      const hasOptions = [1, 2, 3].some(function(n) {
        const raw = productThumb.getAttribute('data-variant-option' + n);
        return raw && raw !== '[]';
      });
      const variantId = productThumb.getAttribute('data-variant-id') ||
        link.getAttribute('data-variant-id');
      if (!hasOptions && !variantId) return;
      product.switchVariantByOptions({
        target: section,
        detail: {
          options: [
            productThumb.getAttribute('data-variant-option1') || '[]',
            productThumb.getAttribute('data-variant-option2') || '[]',
            productThumb.getAttribute('data-variant-option3') || '[]'
          ],
          variantId: variantId || null,
          thumb: productThumb
        }
      });
    }, true);
  }

  wrapVariantAvailability();
  wrapVariantSelection();
  wrapProductImageSetSlider();
  function stampProductInstances() {
    const instances = (window.theme && theme.sections && theme.sections.instances) || [];
    instances.forEach(function(product) {
      if (!product || !product.container) return;
      if (product.type && product.type !== 'product') return;
      product.container._starfireProduct = product;
      if (product.variants) product.container._starfireVariants = product.variants;
    });
    // Also stamp any product section not in theme.sections.instances
    document.querySelectorAll('[data-section-type="product"]').forEach(function(section) {
      if (section._starfireProduct) return;
      const instances2 = (window.theme && theme.sections && theme.sections.instances) || [];
      for (let i = 0; i < instances2.length; i++) {
        if (instances2[i] && instances2[i].container === section) {
          section._starfireProduct = instances2[i];
          if (instances2[i].variants) section._starfireVariants = instances2[i].variants;
          break;
        }
      }
    });
  }

  function scheduleProductBootstrap() {
    setTimeout(function() {
      wrapVariantAvailability();
      wrapVariantSelection();
      wrapProductImageSetSlider();
      wrapStarfireProductUi();
      stampProductInstances();
      hydrateInventoriesFromDom(document);
      runProductBootstrap();
    }, 0);
  }

  document.addEventListener('DOMContentLoaded', scheduleProductBootstrap);

  const HIGH_VARIANT_LIMIT = 250;
  // Liquid caps product.variants JSON around 250. Any PDP (classic or Flex)
  // above that must resolve missing combos via Section Rendering + option_values.
  const HIGH_VARIANT_SUFFIX = 'high-variant';

  function getVariantJsonEl(container) {
    return container && container.querySelector('[data-variant-json]');
  }

  function isHighVariantOptIn(container) {
    if (!container) return false;
    const jsonEl = getVariantJsonEl(container);
    const count = parseInt((jsonEl && jsonEl.dataset.variantsCount) || '0', 10) || 0;
    if (count > HIGH_VARIANT_LIMIT) return true;
    const form = container.querySelector('[data-product-template]');
    const suffix =
      (form && form.getAttribute('data-product-template')) ||
      container.getAttribute('data-template-suffix') ||
      '';
    return String(suffix) === HIGH_VARIANT_SUFFIX ||
      String(suffix).indexOf(HIGH_VARIANT_SUFFIX) !== -1;
  }

  function isHighVariantProduct(container) {
    if (!isHighVariantOptIn(container)) return false;
    const jsonEl = getVariantJsonEl(container);
    if (!jsonEl) return false;
    const count = parseInt(jsonEl.dataset.variantsCount, 10) || 0;
    return count > HIGH_VARIANT_LIMIT && Boolean(jsonEl.dataset.sectionId);
  }

  function wrapHighVariantAvailability() {
    if (!window.theme || !theme.VariantAvailability) return;
    const proto = theme.VariantAvailability.prototype;
    if (proto._starfireHighVariantSkip) return;
    proto._starfireHighVariantSkip = true;

    const originalInitial = proto.setInitialAvailability;
    proto.setInitialAvailability = function() {
      if (isHighVariantProduct(this.container)) return;
      return originalInitial.call(this);
    };

    const originalSet = proto.setAvailability;
    proto.setAvailability = function(evt) {
      if (isHighVariantProduct(this.container)) return;
      return originalSet.call(this, evt);
    };
  }

  function selectedOptionValueIds(container) {
    const radios = Array.from(container.querySelectorAll('[data-variant-input][data-option-value-id]'));
    if (!radios.length) {
      return Array.from(container.querySelectorAll('select[data-variant-input]')).map((select) => {
        const option = select.options[select.selectedIndex];
        return option && option.dataset.optionValueId;
      }).filter(Boolean);
    }
    return radios.filter((input) => input.checked).map((input) => input.dataset.optionValueId).filter(Boolean);
  }

  function parseVariantFromSection(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const jsonEl = doc.querySelector('[data-current-variant-json]');
    let variant = null;
    if (jsonEl) {
      try {
        const parsed = JSON.parse(jsonEl.textContent);
        if (parsed && parsed.id) variant = parsed;
      } catch (err) {
        variant = null;
      }
    }
    return { doc: doc, variant: variant };
  }

  function copyOptionState(fromDoc, container) {
    fromDoc.querySelectorAll('.variant-input[data-value]').forEach((el) => {
      const value = el.getAttribute('data-value');
      const index = el.getAttribute('data-index');
      if (!value || !index) return;
      let local = null;
      container.querySelectorAll('.variant-input[data-index="' + index + '"]').forEach((candidate) => {
        if (candidate.getAttribute('data-value') === value) local = candidate;
      });
      if (!local) return;
      const srcInput = el.querySelector('input');
      const srcLabel = el.querySelector('label');
      const dstInput = local.querySelector('input');
      const dstLabel = local.querySelector('label');
      if (srcInput && dstInput) {
        dstInput.classList.toggle('disabled', srcInput.classList.contains('disabled'));
        dstInput.classList.toggle('instock', srcInput.classList.contains('instock'));
      }
      if (srcLabel && dstLabel) {
        dstLabel.classList.toggle('disabled', srcLabel.classList.contains('disabled'));
        dstLabel.classList.toggle('instock', srcLabel.classList.contains('instock'));
      }
    });

    fromDoc.querySelectorAll('select[data-variant-input] option[data-option-value-id]').forEach((srcOption) => {
      const selectIndex = srcOption.getAttribute('data-index');
      const value = srcOption.value;
      const localSelect = container.querySelector('select[data-variant-input][data-index="' + selectIndex + '"]');
      if (!localSelect) return;
      Array.from(localSelect.options).forEach((dstOption) => {
        if (dstOption.value !== value) return;
        dstOption.disabled = srcOption.disabled;
      });
    });
  }

  function ensureMasterSelectOption(container, variant) {
    const select = container.querySelector('[data-product-select]');
    if (!select || !variant || !variant.id) return;
    const id = String(variant.id);
    const exists = Array.from(select.options).some((option) => option.value === id);
    if (!exists) {
      const option = document.createElement('option');
      option.value = id;
      option.textContent = variant.name || variant.title || id;
      select.appendChild(option);
    }
  }

  function fetchHighVariantSection(container, optionValueIds) {
    const jsonEl = getVariantJsonEl(container);
    const url = new URL(window.location.href);
    url.searchParams.set('section_id', jsonEl.dataset.sectionId);
    if (optionValueIds.length) {
      url.searchParams.set('option_values', optionValueIds.join(','));
    } else {
      url.searchParams.delete('option_values');
    }
    url.searchParams.delete('variant');
    return fetch(url.toString()).then((response) => {
      if (!response.ok) throw new Error('High-variant section request failed');
      return response.text();
    });
  }

  function findProductInstance(container) {
    const instances = (window.theme && theme.sections && theme.sections.instances) || [];
    if (!container) return null;
    const sectionId = container.getAttribute('data-section-id');
    const productId = container.getAttribute('data-product-id');
    return instances.find((instance) => instance.container === container) ||
      instances.find((instance) => instance.type === 'product' && instance.id === sectionId) ||
      instances.find((instance) => {
        return instance.type === 'product' &&
          instance.container &&
          String(instance.productId) === String(productId);
      }) ||
      instances.find((instance) => {
        return instance.type === 'product' &&
          instance.container &&
          instance.container.contains(container);
      }) ||
      instances.find((instance) => {
        return instance.variants &&
          instance.container &&
          sectionId &&
          instance.container.getAttribute('data-section-id') === sectionId;
      }) ||
      null;
  }

  function applyForcedVariant(variantsUi, variant, input) {
    if (!variantsUi || !variant || !theme.Variants) return;
    if (Array.isArray(variantsUi.variants) &&
        !variantsUi.variants.some((entry) => String(entry.id) === String(variant.id))) {
      variantsUi.variants.push(variant);
    }
    ensureMasterSelectOption(variantsUi.container, variant);
    // Drive the full Impulse update path with the section-resolved variant so we
    // never re-match against a truncated >250 JSON blob.
    theme.Variants.prototype._onSelectChange.call(variantsUi, {
      srcElement: input || variantsUi.container.querySelector('[data-variant-input]:checked'),
      target: input || variantsUi.container.querySelector('[data-variant-input]:checked'),
      forcedVariant: variant
    });
  }

  function applyHighVariantPayload(container, html, input) {
    const product = container._starfireProduct || findProductInstance(container);
    const variantsUi = (product && product.variants) || container._starfireVariants;
    const parsed = parseVariantFromSection(html);
    copyOptionState(parsed.doc, container);
    if (parsed.variant) {
      ensureMasterSelectOption(container, parsed.variant);
      if (variantsUi) {
        applyForcedVariant(variantsUi, parsed.variant, input);
      } else {
        const select = container.querySelector('[data-product-select]');
        if (select) {
          select.value = String(parsed.variant.id);
        }
        syncVariantUrl(container);
      }
      copyOptionState(parsed.doc, container);
      return;
    }
    if (variantsUi && input && theme.Variants) {
      theme.Variants.prototype._onSelectChange.call(variantsUi, {
        srcElement: input,
        target: input
      });
      copyOptionState(parsed.doc, container);
    }
  }

  function hydrateHighVariantProducts() {
    document.querySelectorAll('[data-variant-json][data-variants-count]').forEach((jsonEl) => {
      const container = jsonEl.closest('[data-section-type="product"]') || jsonEl.closest('[data-section-id]');
      if (!isHighVariantProduct(container) || container._starfireHydrating) return;
      container._starfireHydrating = true;

      // Quiet seed only — never fire _onSelectChange / gallery remount on load.
      // That was overriding the Liquid first image AND thumbnail set.
      const product = container._starfireProduct || findProductInstance(container);
      const variantsUi = (product && product.variants) || container._starfireVariants;
      const currentEl = container.querySelector('[data-current-variant-json]');
      if (currentEl && variantsUi && Array.isArray(variantsUi.variants)) {
        try {
          const current = JSON.parse(currentEl.textContent);
          if (current && current.id) {
            if (!variantsUi.variants.some(function(variant) {
              return String(variant.id) === String(current.id);
            })) {
              variantsUi.variants.push(current);
            }
            ensureMasterSelectOption(container, current);
            variantsUi.currentVariant = current;
          }
        } catch (err) {}
      }

      fetchHighVariantSection(container, selectedOptionValueIds(container))
        .then((html) => {
          const parsed = parseVariantFromSection(html);
          copyOptionState(parsed.doc, container);
          if (parsed.variant && variantsUi && Array.isArray(variantsUi.variants)) {
            if (!variantsUi.variants.some(function(variant) {
              return String(variant.id) === String(parsed.variant.id);
            })) {
              variantsUi.variants.push(parsed.variant);
            }
            ensureMasterSelectOption(container, parsed.variant);
            // Keep Liquid selection — only refresh availability classes from section.
            const select = container.querySelector('[data-product-select]');
            if (select && String(select.value) === String(parsed.variant.id)) {
              variantsUi.currentVariant = parsed.variant;
            }
          }
          container._starfireHydrating = false;
        })
        .catch(() => {
          container._starfireHydrating = false;
        });
    });
  }

  // Document capture removed. Option changes are rebound in wrapVariantsConstructor
  // so our prototype _onSelectChange always runs (Impulse's .bind kept the original).

  wrapHighVariantAvailability();
  document.addEventListener('DOMContentLoaded', function() {
    wrapHighVariantAvailability();
    wrapVariantsConstructor();
    hydrateHighVariantProducts();
  });
  hydrateHighVariantProducts();

  function syncVariantUrl(container) {
    const select = container && container.querySelector('[data-product-select]');
    if (!select || !select.value || !history.replaceState) return;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', select.value);
    history.replaceState({ path: url.href }, '', url.pathname + url.search + url.hash);
  }

  function hydrateInventoriesFromDom(root) {
    const scope = root || document;
    window.inventories = window.inventories || {};
    scope.querySelectorAll('.js-product-inventory-data[data-product-id]').forEach(function(el) {
      const productId = el.getAttribute('data-product-id');
      if (!productId) return;
      window.inventories[productId] = {};
      el.querySelectorAll('.js-variant-inventory-data[data-id]').forEach(function(row) {
        window.inventories[productId][row.getAttribute('data-id')] = {
          quantity: row.getAttribute('data-quantity'),
          policy: row.getAttribute('data-policy'),
          incoming: row.getAttribute('data-incoming') === 'true',
          next_incoming_date: row.getAttribute('data-date')
        };
      });
    });
  }

  function afterProductSectionSwap() {
    wrapVariantAvailability();
    wrapVariantSelection();
    wrapVariantsConstructor();
    wrapProductImageSetSlider();
    wrapStarfireProductUi();
    wrapHighVariantAvailability();
    stampProductInstances();
    hydrateInventoriesFromDom(document);
    hydrateHighVariantProducts();
    runProductBootstrap();
    document.querySelectorAll('[data-section-type="product"]').forEach(syncVariantUrl);
  }

  if (!window._starfireProductSwapBound) {
    window._starfireProductSwapBound = true;
    document.addEventListener('shopify:section:load', afterProductSectionSwap);
    document.addEventListener('swatchSwitcher:switched', afterProductSectionSwap);
  }

  const preorderProperty = (window.theme && theme.settings && theme.settings.preorderProperty) || 'Number of PRE-ORDERED item(s)';
  const preorderText = (window.theme && theme.strings && theme.strings.addToCartPreorder) || 'Pre-order';
  const addToCartText = (window.theme && theme.strings && theme.strings.addToCart) || 'Add to cart';
  const soldOutText = (window.theme && theme.strings && theme.strings.soldOut) || 'Sold Out';
  const unavailableText = (window.theme && theme.strings && theme.strings.unavailable) || 'Unavailable';

  function parseInventoryNumber(value) {
    if (value == null || value === '') return null;
    const parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? null : parsed;
  }

  function readBisInventory(container, variantId) {
    const dataEl = container.querySelector('[data-bis-display-data]');
    if (!dataEl) return null;
    try {
      const rows = JSON.parse(dataEl.textContent);
      return Array.isArray(rows) ? rows.find((row) => String(row.id) === String(variantId)) : null;
    } catch (err) {
      return null;
    }
  }

  function resolveVariantInventory(form, variant) {
    const resolved = Object.assign({}, variant || {});
    if (!resolved.id) {
      resolved._inventoryKnown = false;
      return resolved;
    }

    const container = (form && (form.closest('[data-section-type="product"]') || form.closest('[data-product-id]'))) || document;
    let knownQty = null;
    let knownPolicy = resolved.inventory_policy;
    let knownManagement = resolved.inventory_management;

    const applyQty = function(value, overwrite) {
      const qty = parseInventoryNumber(value);
      if (qty == null) return;
      if (knownQty == null || overwrite) knownQty = qty;
    };

    // Prefer Liquid JSON / BIS payload — they survive family swaps (inline scripts
    // injected via innerHTML do not re-run, so window.inventories can be stale).
    const jsonEl = container.querySelector('[data-variant-json]');
    if (jsonEl) {
      try {
        const variants = JSON.parse(jsonEl.textContent);
        const full = Array.isArray(variants) && variants.find((entry) => String(entry.id) === String(resolved.id));
        if (full) {
          applyQty(full.inventory_quantity, true);
          if (full.inventory_management != null) knownManagement = full.inventory_management;
          if (full.inventory_policy != null) knownPolicy = full.inventory_policy;
          if (full.available != null) resolved.available = full.available;
        }
      } catch (err) {}
    }

    const bisRow = readBisInventory(container, resolved.id);
    if (bisRow) {
      applyQty(bisRow.inventory_quantity, knownQty == null);
      if (bisRow.inventory_management != null && knownManagement == null) knownManagement = bisRow.inventory_management;
      if (bisRow.inventory_policy != null && knownPolicy == null) knownPolicy = bisRow.inventory_policy;
      if (bisRow.available != null && resolved.available == null) resolved.available = bisRow.available;
    }

    const dataEl = container.querySelector('.js-variant-inventory-data[data-id="' + resolved.id + '"]');
    if (dataEl) {
      applyQty(dataEl.getAttribute('data-quantity'), knownQty == null);
      const policy = dataEl.getAttribute('data-policy');
      if (policy && policy !== 'false' && knownPolicy == null) knownPolicy = policy;
    }

    const productId = container.getAttribute && container.getAttribute('data-product-id');
    const inventoryMap = window.inventories && productId && window.inventories[productId];
    if (inventoryMap && knownQty == null) {
      const inventoryRecord = inventoryMap[resolved.id] || inventoryMap[String(resolved.id)];
      if (inventoryRecord) {
        applyQty(inventoryRecord.quantity, true);
        if (inventoryRecord.policy && inventoryRecord.policy !== 'false' && knownPolicy == null) {
          knownPolicy = inventoryRecord.policy;
        }
      }
    }

    if (knownQty == null) applyQty(variant && variant.inventory_quantity, true);

    resolved.inventory_quantity = knownQty;
    resolved.inventory_policy = knownPolicy;
    resolved.inventory_management = knownManagement;
    resolved._inventoryKnown = knownQty != null;
    return resolved;
  }

  function cartCountsForVariant(cart, variantId) {
    let qty = 0;
    let preorders = 0;
    (cart.items || []).forEach((item) => {
      if (String(item.id) !== String(variantId) && String(item.variant_id) !== String(variantId)) return;
      qty += item.quantity || 0;
      const raw = item.properties && item.properties[preorderProperty];
      if (raw) preorders += parseInt(raw, 10) || 0;
    });
    return { qty: qty, preorders: preorders };
  }

  function dawnIsPreorder(form, variant, shopQty) {
    if (!variant || !variant.available) return false;
    // Gift cards and similar never use Pre-order.
    if (form && form.getAttribute('data-product-gift-card') === 'true') return false;
    const onPreorderTemplate = ((form && form.dataset.productTemplate) || '').indexOf('preorder') !== -1;
    if (onPreorderTemplate) return true;
    // Not tracked in Admin → always Add to cart (never Pre-order).
    // Shopify often reports qty 0 for untracked items — do not treat that as OOS preorder.
    const management = variant.inventory_management;
    if (management == null || management === '' || management !== 'shopify') return false;
    // Theme-native preorder: tracked + continue selling + known shop qty is 0.
    if (!variant._inventoryKnown) return false;
    if (shopQty > 0) return false;
    return variant.inventory_policy === 'continue';
  }

  function lockCartButtonLabel(form) {
    const buttonText = form.querySelector('[data-add-to-cart-text]');
    if (!buttonText || buttonText._starfireLabelObserver) return;
    buttonText._starfireLabelObserver = new MutationObserver(function() {
      const wanted = buttonText.dataset.starfireLabel;
      if (wanted && buttonText.textContent !== wanted) {
        buttonText.textContent = wanted;
      }
    });
    buttonText._starfireLabelObserver.observe(buttonText, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  function applyPreorderUi(form, variant, inventoryQty, isPreorder) {
    const preorderInput = form.querySelector('[data-is-preorder]');
    const invInput = form.querySelector('[data-variant-inv]');
    const remainingInput = form.querySelector('[data-variant-inv-remaining]');
    const button = form.querySelector('[data-add-to-cart]');
    const buttonText = form.querySelector('[data-add-to-cart-text]');
    const message = form.querySelector('[data-preorder-message]');

    if (preorderInput) preorderInput.value = isPreorder ? 'true' : 'false';
    if (invInput && inventoryQty != null && inventoryQty !== '') invInput.value = inventoryQty;
    if (remainingInput && inventoryQty != null && inventoryQty !== '') remainingInput.value = inventoryQty;
    syncPreorderPropertyInput(form, isPreorder);
    lockCartButtonLabel(form);

    if (button) {
      button.disabled = false;
      button.classList.remove('disabled');
      button.classList.toggle('preorder', isPreorder);
    }
    form.querySelectorAll('.shopify-payment-button').forEach((el) => {
      el.classList.toggle('hide', isPreorder);
    });
    if (message) {
      message.classList.toggle('hide', !isPreorder);
    }
    if (buttonText && variant.available) {
      const nextText = isPreorder ? preorderText : addToCartText;
      buttonText.dataset.defaultText = nextText;
      buttonText.dataset.starfireLabel = nextText;
      buttonText.textContent = nextText;
    }
    togglePreorderTerms(form, isPreorder);
  }

  function updatePreorderUi(form, variant) {
    if (!form || !variant) return;
    const resolved = resolveVariantInventory(form, variant);
    const qty = resolved._inventoryKnown ? (parseInventoryNumber(resolved.inventory_quantity) || 0) : null;
    // Shop inventory only for the PDP button. Cart-adjusted remaining was racing
    // and flipping in-stock ATC to Pre-order after Liquid painted correctly.
    // (Qty caps still apply at add-to-cart time.)
    applyPreorderUi(
      form,
      resolved,
      qty == null ? '' : qty,
      dawnIsPreorder(form, resolved, qty == null ? 1 : qty)
    );
  }

  function syncStarfireCartButton(container, variant) {
    const form =
      container &&
      (container.querySelector(
        '.product-single__form-original.starfire-preorder-form, form.starfire-preorder-form:not(.product-single__form--upsell)'
      ) ||
        container.querySelector('.product-single__form--upsell') ||
        container.querySelector('.starfire-preorder-form'));
    if (!form) return;

    const button = form.querySelector('[data-add-to-cart]');
    const buttonText = form.querySelector('[data-add-to-cart-text]');
    const message = form.querySelector('[data-preorder-message]');
    const isUpsellLean = form.classList.contains('product-single__form--upsell');

    if (!variant) {
      if (button) {
        button.disabled = true;
        button.classList.add('disabled');
        button.classList.remove('preorder');
      }
      if (buttonText) buttonText.textContent = unavailableText;
      if (message) message.classList.add('hide');
      if (!isUpsellLean) togglePreorderTerms(form, false);
      if (isUpsellLean) form.dataset.upsellUnavailable = 'true';
      return;
    }

    if (!variant.available) {
      if (button) {
        button.disabled = true;
        button.classList.add('disabled');
        button.classList.remove('preorder');
      }
      if (buttonText) {
        buttonText.dataset.defaultText = addToCartText;
        buttonText.textContent = soldOutText;
      }
      if (message) message.classList.add('hide');
      form.querySelectorAll('.shopify-payment-button').forEach(function(el) {
        el.classList.remove('hide');
      });
      if (!isUpsellLean) togglePreorderTerms(form, false);
      if (isUpsellLean) form.dataset.upsellUnavailable = 'true';
      return;
    }

    if (isUpsellLean) {
      if (button) {
        button.disabled = false;
        button.classList.remove('disabled');
        button.classList.remove('preorder');
      }
      // Keep Liquid "Add this" (data-default-text) — never overwrite with Add to cart.
      if (buttonText) {
        const upsellLabel = buttonText.dataset.defaultText || buttonText.textContent || addToCartText;
        buttonText.dataset.defaultText = upsellLabel;
        buttonText.textContent = upsellLabel;
      }
      delete form.dataset.upsellUnavailable;
      return;
    }

    updatePreorderUi(form, variant);
  }

  function syncProductSection(container) {
    if (!container) return;
    applyInstockFromJson(container);
    const product = container._starfireProduct || findProductInstance(container);
    const variant = product && product.variants && product.variants.currentVariant;
    // Do not touch gallery/thumbs here — load remounts were wiping Liquid's
    // starting image + thumbnail set. Clicks go through updateImageSet / goTo.
    syncStarfireCartButton(container, variant || null);
  }

  function runProductBootstrap() {
    stampProductInstances();
    const instances = (window.theme && theme.sections && theme.sections.instances) || [];
    instances.forEach(function(product) {
      if (!product || !product.variants) return;
      // Do not force-rebind classic PDPs (cloning radios twice broke metal clicks).
      // High-variant opt-in still needs the section-fetch listener once.
      if (
        product.container &&
        isHighVariantProduct(product.container) &&
        !product.variants._starfireChangeRebound
      ) {
        rebindVariantChangeListeners(product.variants);
      }
      if (product.container) {
        product.container._starfireProduct = product;
        product.container._starfireVariants = product.variants;
      }
      ensureImageSetWiring(product);
      syncThumbsWithRetries(product, 8);
    });
    document.querySelectorAll('[data-section-type="product"] [data-variant-json]').forEach(function(jsonEl) {
      const container = jsonEl.closest('[data-section-type="product"]');
      if (!container) return;
      // Liquid already chose the variant (and first in-stock when needed).
      // Never auto-click options on load — that remounted images + thumbs.
      syncProductSection(container);
    });
  }

  function wrapStarfireProductUi() {
    if (!window.theme || !theme.Product) return;
    const proto = theme.Product.prototype;
    if (proto._starfireProductUiWrapped) return;
    proto._starfireProductUiWrapped = true;

    const originalUpdateCartButton = proto.updateCartButton;
    proto.updateCartButton = function(evt) {
      const variant = evt.detail && evt.detail.variant;
      const form =
        this.container &&
        (this.container.querySelector(
          '.product-single__form-original.starfire-preorder-form, form.starfire-preorder-form:not(.product-single__form--upsell)'
        ) ||
          this.container.querySelector('.starfire-preorder-form'));
      if (form) {
        // Own ATC/preorder/sold-out copy — Impulse would restore a stale
        // data-default-text ("Pre-order") and fight our inventory sync.
        syncStarfireCartButton(this.container, variant || null);
        applyInstockFromJson(this.container);
        return;
      }
      originalUpdateCartButton.call(this, evt);
    };
  }

  wrapStarfireProductUi();

  // Single document listener (updateCartButton above already syncs Product sections).
  // Keep this for non-Product contexts and family-switch rehydration.
  if (!window._starfireVariantUiBound) {
    window._starfireVariantUiBound = true;
    document.addEventListener('variant:change', function(evt) {
      const variant = evt.detail && evt.detail.variant;
      // Skip if Impulse Product already handled this via updateCartButton wrap
      // on the same tick for the matching section — still safe to re-sync;
      // updatePreorderUi request ids drop stale cart responses.
      document.querySelectorAll('[data-section-type="product"]').forEach(function(section) {
        if (variant) {
          const select = section.querySelector('[data-product-select]');
          const optionMatch = select && select.querySelector('option[value="' + variant.id + '"]');
          const jsonEl = section.querySelector('[data-variant-json]');
          const inJson = jsonEl && jsonEl.textContent.indexOf(String(variant.id)) !== -1;
          if (!optionMatch && !inJson && document.querySelectorAll('[data-section-type="product"]').length > 1) {
            return;
          }
        }
        syncStarfireCartButton(section, variant || null);
        applyInstockFromJson(section);
      });
    });
  }

  if (document.readyState !== 'loading') {
    hydrateInventoriesFromDom(document);
    scheduleProductBootstrap();
  }

  function normalizeProps(props) {
    const clean = Object.assign({}, props || {});
    delete clean[preorderProperty];
    return clean;
  }

  function propsEqual(a, b) {
    return JSON.stringify(normalizeProps(a)) === JSON.stringify(normalizeProps(b));
  }

  function syncPreorderPropertyInput(form, isPreorder) {
    const input = form.querySelector('[data-preorder-qty]');
    if (!input) return;
    const qtyField = form.querySelector('[name="quantity"]');
    const qty = parseInt((qtyField && qtyField.value) || '1', 10) || 1;
    if (isPreorder) {
      input.disabled = false;
      input.name = 'properties[' + preorderProperty + ']';
      input.value = String(qty);
    } else {
      input.disabled = true;
      input.value = '';
    }
  }

  function appendAssociatedFields(form, formData) {
    if (!form || !form.id || !formData) return formData;
    document.querySelectorAll('[form="' + form.id + '"]').forEach((el) => {
      if (!el.name || el.disabled) return;
      // Never clobber the variant id — option selects / twin modals can share form=.
      if (el.name === 'id') return;
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
      if (el.value === '' || el.value == null) {
        formData.delete(el.name);
        return;
      }
      formData.set(el.name, el.value);
    });
    return formData;
  }

  function stampUpsellVariantId(form, formData) {
    if (!form || !formData) return formData;
    const isUpsellForm =
      form.closest('.modal-upsell') ||
      form.closest('[data-upsell-holder]') ||
      form.classList.contains('product-single__form--upsell');
    if (!isUpsellForm) return formData;

    let variant = null;
    if (typeof window.starfireForceUpsellVariantOnForm === 'function') {
      variant = window.starfireForceUpsellVariantOnForm(form);
    }
    if (variant && variant.id) {
      formData.set('id', String(variant.id));
      return formData;
    }
    const stamped = form.querySelector('input[data-upsell-variant-id]');
    if (stamped && stamped.value) formData.set('id', stamped.value);
    return formData;
  }

  function collectProperties(formData) {
    const props = {};
    formData.forEach((value, key) => {
      if (key.startsWith('properties[') && value !== '') {
        props[key.slice(11, -1)] = value;
      }
    });
    return props;
  }

  function wrapAjaxProduct() {
    if (!window.theme || !theme.AjaxProduct) return;
    const proto = theme.AjaxProduct.prototype;
    if (proto._starfirePreorderWrapped) return;
    proto._starfirePreorderWrapped = true;
    const original = proto.addItemFromForm;

    proto.addItemFromForm = function(evt, callback) {
      // Upsell QuickShop / popup: never use Impulse+preorder path (wrong id + /cart redirect).
      if (this.form && (
        this.form.closest('.modal-upsell') ||
        this.form.closest('[data-upsell-holder]') ||
        this.form.classList.contains('product-single__form--upsell')
      )) {
        if (evt) {
          evt.preventDefault();
          evt.stopPropagation();
          if (evt.stopImmediatePropagation) evt.stopImmediatePropagation();
        }
        if (typeof window.submitStarfireUpsellForm === 'function') {
          window.submitStarfireUpsellForm(this.form, evt);
          return;
        }
        if (typeof window.starfireForceUpsellVariantOnForm === 'function') {
          window.starfireForceUpsellVariantOnForm(this.form);
        }
        // Still never fall through to page cart redirect for upsell forms.
        return;
      }

      if (!this.form || !this.form.classList.contains('starfire-preorder-form')) {
        return original.call(this, evt, callback);
      }

      evt.preventDefault();
      if (this.addToCart && this.addToCart.classList.contains('btn--loading')) return;
      if (this.addToCart) this.addToCart.classList.add('btn--loading');

      const formData = stampUpsellVariantId(
        this.form,
        appendAssociatedFields(this.form, new FormData(this.form))
      );
      const isPreorder = formData.get('preorder') === 'true';
      const variantId = parseInt(formData.get('id'), 10);
      const qtyAdding = parseInt(formData.get('quantity') || '1', 10);
      const variantProps = collectProperties(formData);

      fetch(theme.routes.cart)
        .then((response) => response.json())
        .then((cart) => {
          const matching = (cart.items || []).find((item) => item.id === variantId && propsEqual(item.properties || {}, variantProps));
          let preorderCount = 0;
          if (matching) {
            preorderCount = parseInt((matching.properties && matching.properties[preorderProperty]) || 0, 10) + (isPreorder ? qtyAdding : 0);
          } else if (isPreorder) {
            preorderCount = qtyAdding;
          }
          if (preorderCount > 0) variantProps[preorderProperty] = String(preorderCount);

          formData.delete('preorder');
          formData.delete('variant_inv');
          formData.delete('variant_inv_remaining');
          formData.delete('variant_cart_qty');
          formData.delete('variant_cart_preorders');
          Object.keys(variantProps).forEach((key) => {
            formData.set('properties[' + key + ']', variantProps[key]);
          });

          if (!matching) {
            const data = formData;
            return fetch(theme.routes.cartAdd, {
              method: 'POST',
              body: data,
              headers: { 'X-Requested-With': 'XMLHttpRequest' }
            }).then((response) => response.json())
              .then((payload) => {
                if (this.addToCart) this.addToCart.classList.remove('btn--loading');
                if (payload.status === 422) {
                  this.error(payload);
                } else {
                  this.success(payload);
                }
              });
          }

          const changeData = new FormData();
          changeData.append('id', matching.key);
          changeData.append('quantity', matching.quantity + qtyAdding);
          Object.keys(variantProps).forEach((key) => {
            changeData.set('properties[' + key + ']', variantProps[key]);
          });
          return fetch(theme.routes.cartChange, {
            method: 'POST',
            body: changeData,
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          }).then((response) => response.json())
            .then((payload) => {
              if (this.addToCart) this.addToCart.classList.remove('btn--loading');
              if (payload.status === 422) {
                this.error(payload);
              } else {
                const line = (payload.items || []).find((item) => item.key === matching.key) || matching;
                this.success(line);
              }
            });
        })
        .catch(() => {
          if (this.addToCart) this.addToCart.classList.remove('btn--loading');
          return original.call(this, evt, callback);
        });
    };
  }

  wrapAjaxProduct();
  document.addEventListener('DOMContentLoaded', wrapAjaxProduct);

  function initPreorderPropertyInputs() {
    document.querySelectorAll('.starfire-preorder-form').forEach((form) => {
      const preorderInput = form.querySelector('[data-is-preorder]');
      syncPreorderPropertyInput(form, Boolean(preorderInput && preorderInput.value === 'true'));
      const qtyField = form.querySelector('[name="quantity"]');
      if (qtyField && !qtyField.dataset.preorderQtyBound) {
        qtyField.dataset.preorderQtyBound = 'true';
        qtyField.addEventListener('change', function() {
          syncPreorderPropertyInput(form, Boolean(preorderInput && preorderInput.value === 'true'));
        });
      }
    });
  }
  initPreorderPropertyInputs();
  document.addEventListener('DOMContentLoaded', initPreorderPropertyInputs);

  function togglePreorderTerms(form, hasPreorder) {
    if (!form) return;
    const row = form.querySelector('[data-preorder-terms]');
    const box = row && row.querySelector('input[type="checkbox"]');
    const wallets = form.querySelector('.additional-checkout-buttons');

    if (row) row.classList.toggle('hide', !hasPreorder);
    if (box) {
      box.disabled = !hasPreorder;
      box.required = Boolean(hasPreorder);
      if (!hasPreorder) box.checked = false;
    }
    if (wallets) wallets.classList.toggle('hide', Boolean(hasPreorder));
    syncCartPreorderTerms(form);
  }

  function wrapCartForm() {
    if (!window.theme || !theme.CartForm) return;
    const proto = theme.CartForm.prototype;
    if (proto._starfirePreorderCartWrapped) return;
    proto._starfirePreorderCartWrapped = true;
    const original = proto.cartMarkup;
    proto.cartMarkup = function(text) {
      original.call(this, text);
      const items = this.products && this.products.querySelector('.cart__items');
      const hasPreorder = items && items.dataset.hasPreorder === 'true';
      togglePreorderTerms(this.form, hasPreorder);
    };
  }

  function productJsPath(handle) {
    const root = (window.theme && theme.routes && theme.routes.home) || '/';
    const prefix = root === '/' ? '' : String(root).replace(/\/$/, '');
    return prefix + '/products/' + handle + '.js';
  }

  function attachPreorderToLine(lineItem) {
    if (!lineItem || !lineItem.handle || !lineItem.key) return Promise.resolve(false);
    const cartUrl = window.theme && theme.routes && theme.routes.cart;
    const changeUrl = window.theme && theme.routes && theme.routes.cartChange;
    if (!cartUrl || !changeUrl) return Promise.resolve(false);

    return fetch(productJsPath(lineItem.handle))
      .then((response) => response.json())
      .then((product) => {
        const variant = (product.variants || []).find((entry) => entry.id === lineItem.id || entry.id === lineItem.variant_id);
        if (!variant || !variant.available) return false;
        const onPreorderTemplate = String(product.template_suffix || '').indexOf('preorder') !== -1;
        // Untracked inventory must never get a preorder line property.
        if (!onPreorderTemplate) {
          if (variant.inventory_management !== 'shopify') return false;
          if (variant.inventory_policy !== 'continue') return false;
        }

        return fetch(cartUrl)
          .then((response) => response.json())
          .then((cart) => {
            const counts = cartCountsForVariant(cart, variant.id);
            const needed = onPreorderTemplate
              ? counts.qty
              : Math.max(0, counts.qty - (parseInt(variant.inventory_quantity, 10) || 0));
            const currentOnLine = parseInt((lineItem.properties && lineItem.properties[preorderProperty]) || 0, 10) || 0;
            const otherPreorders = Math.max(0, counts.preorders - currentOnLine);
            const lineNeeded = Math.min(lineItem.quantity, Math.max(0, needed - otherPreorders));
            if (lineNeeded === currentOnLine) return false;

            const props = Object.assign({}, lineItem.properties || {});
            if (lineNeeded > 0) {
              props[preorderProperty] = String(lineNeeded);
            } else {
              delete props[preorderProperty];
            }

            return fetch(changeUrl, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify({
                id: lineItem.key,
                quantity: lineItem.quantity,
                properties: props
              })
            }).then(() => true);
          });
      })
      .catch(() => false);
  }

  function ensureCartPreorderProperties() {
    const cartUrl = window.theme && theme.routes && theme.routes.cart;
    if (!cartUrl) return Promise.resolve();
    return fetch(cartUrl)
      .then((response) => response.json())
      .then((cart) => {
        return (cart.items || []).reduce((chain, item) => {
          return chain.then(() => attachPreorderToLine(item));
        }, Promise.resolve());
      });
  }
  window.starfireEnsureCartPreorderProperties = ensureCartPreorderProperties;

  function wrapCartAddFetch() {
    if (window._starfireCartAddWrapped || !window.fetch) return;
    window._starfireCartAddWrapped = true;
    const originalFetch = window.fetch.bind(window);
    window.fetch = function(input, init) {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      const isCartAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);
      return originalFetch(input, init).then((response) => {
        if (!isCartAdd) return response;
        response.clone().json().then((payload) => {
          const items = payload.items || (payload.key || payload.id ? [payload] : []);
          items.reduce((chain, item) => chain.then(() => attachPreorderToLine(item)), Promise.resolve());
        }).catch(() => {});
        return response;
      });
    };
  }
  wrapCartAddFetch();

  function wrapCartChangeItem() {
    if (!window.theme || !theme.cart || theme.cart._starfirePreorderChangeWrapped) return;
    theme.cart._starfirePreorderChangeWrapped = true;
    const original = theme.cart.changeItem.bind(theme.cart);
    theme.cart.changeItem = function(key, qty) {
      const row = Array.from(document.querySelectorAll('.cart__item[data-key]')).find((el) => el.dataset.key === key);
      if (!row) return original(key, qty);

      const variantTotalCartQty = parseInt(row.dataset.variantCartQty, 10) || 0;
      const variantTotalCartPreorders = parseInt(row.dataset.variantCartPreorders, 10) || 0;
      const variantTotalInventory = parseInt(row.dataset.variantInv, 10) || 0;
      const itemCurrentQty = parseInt(row.dataset.qty, 10) || 0;
      const itemCurrentPreorderCount = parseInt(row.dataset.variantPreorders, 10) || 0;
      const variantNewTotalCartQty = variantTotalCartQty - itemCurrentQty + qty;
      const preOrdersNeeded = Math.max(0, variantNewTotalCartQty - variantTotalInventory);
      const preOrderAdjustment = preOrdersNeeded - variantTotalCartPreorders;
      const newPreOrdersTotal = Math.min(Math.max(0, itemCurrentPreorderCount + preOrderAdjustment), Math.max(0, variantNewTotalCartQty));

      if (preOrderAdjustment === 0) return original(key, qty);

      return theme.cart.getCart().then((cart) => {
        const item = (cart.items || []).find((entry) => entry.key === key);
        const props = Object.assign({}, (item && item.properties) || {});
        if (newPreOrdersTotal > 0) {
          props[preorderProperty] = String(newPreOrdersTotal);
        } else {
          delete props[preorderProperty];
        }
        return theme.cart._updateCart({
          url: theme.routes.cartChange + '?t=' + Date.now(),
          data: JSON.stringify({
            id: key,
            quantity: qty,
            properties: props
          })
        });
      }).catch(() => original(key, qty));
    };
  }

  wrapCartForm();
  wrapCartChangeItem();
  document.addEventListener('DOMContentLoaded', function() {
    wrapCartForm();
    wrapCartChangeItem();
  });

  function syncCartPreorderTerms(root) {
    const scope = root || document;
    scope.querySelectorAll('.cart__checkout-wrapper').forEach((wrapper) => {
      const form = wrapper.closest('form') || scope;
      const boxes = Array.from(form.querySelectorAll('.cart__terms input[type="checkbox"]')).filter((box) => {
        return !box.disabled && !box.closest('.hide');
      });
      if (!boxes.length) {
        wrapper.dataset.termsRequired = 'false';
        return;
      }
      const allChecked = Array.from(boxes).every((box) => box.checked);
      wrapper.dataset.termsRequired = allChecked ? 'false' : 'true';
    });
  }

  document.addEventListener('input', function(evt) {
    if (!evt.target.matches('.cart__terms input[type="checkbox"]')) return;
    syncCartPreorderTerms(evt.target.closest('form') || document);
  });

  document.addEventListener('click', function(evt) {
    const blocker = evt.target.closest('.cart__checkout-wrapper[data-terms-required="true"]');
    if (!blocker) return;
    evt.preventDefault();
    evt.stopPropagation();
    const message = (window.theme && theme.strings && theme.strings.cartTermsConfirmation) ||
      'You must agree with the terms and conditions of sales to check out';
    alert(message);
  });

  function hideSearchKeywords(root) {
    const scope = root || document;
    // Keep "Search Keywords:" in the DOM (for QA / SEO source) but hide visually.
    // Live removed the span; we hide the wrapping <p> so Elements search still finds it.
    const roots = scope.querySelectorAll(
      '.product-block .rte, .collapsible-content__inner.rte, .product-single__description, [data-product-blocks] .rte'
    );
    const stacks = roots.length ? roots : [scope];
    stacks.forEach(function(rte) {
      if (!rte || !rte.querySelectorAll) return;
      rte.querySelectorAll('p, span').forEach(function(el) {
        const text = (el.textContent || '').replace(/\u00a0/g, ' ').trim();
        if (!/^Search Keywords:/i.test(text)) return;
        const block = el.closest('p') || el;
        if (block.getAttribute('data-search-keywords-hidden') === 'true') return;
        block.setAttribute('data-search-keywords-hidden', 'true');
        block.setAttribute('hidden', '');
        block.setAttribute('aria-hidden', 'true');
        block.style.display = 'none';
      });
    });
  }

  function runHideSearchKeywords() {
    try {
      hideSearchKeywords(document);
    } catch (err) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      syncCartPreorderTerms(document);
      runHideSearchKeywords();
    });
  } else {
    syncCartPreorderTerms(document);
    runHideSearchKeywords();
  }
  document.addEventListener('shopify:section:load', function(evt) {
    hideSearchKeywords((evt && evt.target) || document);
  });
  document.addEventListener('swatchSwitcher:switched', function() {
    setTimeout(runHideSearchKeywords, 0);
  });
})();
